/**
 * @description 系统全局配置
 */
let isProduction = false;
console.log(window.location.href);
// let isProduction = true;
if (window.location.host === "crm.shangshaban.com") {
    isProduction = true;
} else {
    isProduction = false;
}
console.log(isProduction);
export default {
    /**
     * @description 记住密码状态下的token在Cookie中存储的天数，默认1天
     */
    tokenCookieExpires: 1,
    /**
     * @description 记住密码状态下的密码在Cookie中存储的天数，默认1天
     */
    passCookieExpires: 1,
    /**
     * @description 此处修改网站名称
     */
    webName: 'CRM',
    /**
     * @description 是否只保持一个子菜单的展开
     */
    uniqueOpened: true,
    /**
     * @description token key
     */
    TokenKey: 'token',

    /**
     * @description 请求超时时间，毫秒（默认2分钟）
     */
    timeout: 1200000,

    /**
     * @description 是否显示 tagsView
     */
    tagsView: true,

    /**
     * @description 固定头部
     */
    fixedHeader: true,

    /**
     * @description 是否显示logo
     */
    sidebarLogo: true,

    /**
     * 是否显示设置的悬浮按钮
     */
    settingBtn: false,

    /**
     * 是否显示设置的底部信息
     */
    showFooter: true,

    /**
     * 底部文字，支持html语法
     */
    // footerTxt: '© 2019 Zheng Jie <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank">Apache License 2.0</a>',
    footerTxt: '版本：2.3.0',

    /**
     * 备案号
     */
    caseNumber: '鲁ICP备16013214号',
    /**
     * oss上传参数
     */
    ossConfig: {
        region: isProduction ? 'oss-cn-hangzhou' : 'oss-cn-hangzhou',
        internal: true,
        endpoint: isProduction ? 'ssb-crm.shangshaban.com' : 'ssb-crm-debug.shangshaban.com',
        accessKeyId: '',
        accessKeySecret: '',
        stsToken: '',
        bucket: isProduction ? 'ssb-crm' : 'ssb-crm-debug',
        cname: true
    }
}


// WEBPACK FOOTER //
// ./src/config/index.js